import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors as Colors } from '../../themes/Colors';

import { SVGComponentProps } from '../type';

interface IconProps extends SVGComponentProps {
  status: boolean;
  isNotValid: boolean;
}

const UserProfileIcon: FC<IconProps> = ({
  width = 24,
  height = 24,
  status = false,
  isNotValid = false,
  ...other
}) => {
  const fill = isNotValid
    ? Colors.lightRed400
    : status
      ? Colors.cerulean
      : Colors.pickledBluewood;
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 24 24"
        {...other}
      >
        <path
          fill={fill}
          d="M12 12a5 5 0 100-10 5 5 0 000 10z"
          opacity="0.4"
        ></path>
        <path
          fill={fill}
          d="M12 14.5c-5.01 0-9.09 3.36-9.09 7.5 0 .28.22.5.5.5h17.18c.28 0 .5-.22.5-.5 0-4.14-4.08-7.5-9.09-7.5z"
        ></path>
      </svg>
    </SVGUniqueID>
  );
};

export { UserProfileIcon };
